import React from 'react'
import { type LucideProps } from 'lucide-react'

const AIChat: React.FC<LucideProps> = (props: LucideProps) => (
<svg
  width={22}
  height={18}
  viewBox="0 0 22 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M3.07962 0.242956C1.82349 0.242956 0.804199 1.2656 0.804199 2.52331V15.0528C0.804199 16.3106 1.82346 17.3351 3.07962 17.3351L18.9267 17.335C20.1828 17.335 21.2039 16.3105 21.2039 15.0528V2.52324C21.2039 1.26546 20.1828 0.242889 18.9267 0.242889L3.07962 0.242956ZM3.07962 0.881043H18.9267C19.8399 0.881043 20.5665 1.60692 20.5665 2.52331V5.34663H14.8253C12.9269 5.34663 11.3876 6.8879 11.3876 8.78943C11.3876 10.6909 12.9269 12.2315 14.8253 12.2315H20.5665V15.0528C20.5665 15.9692 19.8399 16.6976 18.9267 16.6976H3.07962C2.16634 16.6976 1.44166 15.9692 1.44166 15.0528V2.52331C1.44166 1.60692 2.16634 0.881043 3.07962 0.881043ZM14.8253 5.98404H20.5665V11.5938H14.8253C13.2697 11.5938 12.0251 10.3493 12.0251 8.78918C12.0251 7.22905 13.2698 5.98387 14.8253 5.98387V5.98404ZM15.1808 7.61264C14.5354 7.61264 14.0041 8.14388 14.0041 8.78928C14.0041 9.43467 14.5354 9.96338 15.1808 9.96338C15.8261 9.96338 16.3549 9.43461 16.3549 8.78928C16.3549 8.14388 15.8261 7.61264 15.1808 7.61264ZM15.1808 8.25013C15.4816 8.25013 15.7168 8.4884 15.7168 8.78928C15.7168 9.09009 15.4816 9.32776 15.1808 9.32776C14.8799 9.32776 14.6416 9.0901 14.6416 8.78928C14.6416 8.48847 14.8799 8.25013 15.1808 8.25013Z"
    fill="#949494"
  />
</svg>
)

export default AIChat
